import React from 'react';

/** Toggle switch. Green when on. */
export default function Switch({ label, checked, defaultChecked, onChange, disabled, style, onClick: consumerOnClick, ...rest }) {
  const [internal, setInternal] = React.useState(defaultChecked || false);
  const [focused, setFocused] = React.useState(false);
  const labelId = React.useId();
  const on = checked !== undefined ? checked : internal;
  const toggle = () => {
    if (disabled) return;
    if (checked === undefined) setInternal(!on);
    onChange && onChange(!on);
  };
  const onKeyDown = (e) => {
    if (e.key === ' ' || e.key === 'Enter') {
      if (e.key === ' ') e.preventDefault(); // stop page scroll
      toggle();
    }
  };
  const handleClick = (e) => {
    consumerOnClick && consumerOnClick(e);
    if (!e.defaultPrevented) toggle();
  };
  return (
    <label onClick={handleClick} style={{
      display: 'inline-flex', alignItems: 'center', gap: 10,
      cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.5 : 1, ...style,
    }} {...rest}>
      <span
        role="switch"
        aria-checked={on}
        aria-disabled={disabled || undefined}
        aria-labelledby={label ? labelId : undefined}
        tabIndex={disabled ? -1 : 0}
        onKeyDown={onKeyDown}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        style={{
          width: 44, height: 26, flex: 'none', borderRadius: 'var(--radius-pill)',
          background: on ? 'var(--science-400)' : 'var(--neutral-200)',
          padding: 3, display: 'inline-flex',
          outline: 'none',
          boxShadow: focused ? '0 0 0 3px var(--focus-ring)' : 'none',
          transition: 'background var(--dur-base) var(--ease-out), box-shadow var(--dur-fast) var(--ease-out)',
        }}
      >
        <span style={{
          width: 20, height: 20, borderRadius: 'var(--radius-pill)', background: '#fff',
          boxShadow: 'var(--shadow-xs)',
          transform: on ? 'translateX(18px)' : 'translateX(0)',
          transition: 'transform var(--dur-base) var(--ease-out)',
        }} />
      </span>
      {label && (
        <span id={labelId} style={{
          fontFamily: 'var(--font-sans)', fontSize: 'var(--text-base)',
          letterSpacing: 'var(--track-tight)', color: 'var(--ink)',
        }}>{label}</span>
      )}
    </label>
  );
}
